import React from 'react';
import { useCredits } from '../../contexts/CreditsContext';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function CreditsDisplay() {
  const { credits, plan, planInfo, unlimited, loading } = useCredits();
  const { profile } = useAuth();
  const navigate = useNavigate();

  if (loading) return null;

  const role = profile?.role;
  const pricingPath = role === 'admin'
    ? '/dashboard/admin/pricing'
    : '/dashboard/sales/pricing';

  const handleClick = () => navigate(pricingPath);

  if (unlimited) {
    return (
      <button
        onClick={handleClick}
        title="View plans & pricing"
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold bg-purple-500/15 text-purple-400 border border-purple-500/30 hover:bg-purple-500/20 hover:border-purple-500/50 transition-all"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-purple-400 inline-block" />
        Pro · Unlimited
      </button>
    );
  }

  const low  = credits !== null && credits < 50;
  const warn = credits !== null && credits >= 50 && credits < 200;

  const colors = low
    ? 'bg-red-500/10 text-red-400 border-red-500/30 hover:bg-red-500/15 hover:border-red-500/50'
    : warn
    ? 'bg-yellow-500/10 text-yellow-400 border-yellow-500/30 hover:bg-yellow-500/15 hover:border-yellow-500/50'
    : 'bg-white/5 text-secondary border-white/10 hover:bg-white/10 hover:border-white/20';

  const dotColor = low ? 'bg-red-400' : warn ? 'bg-yellow-400 animate-pulse' : 'bg-green-400';

  return (
    <button
      onClick={handleClick}
      title="View plans & upgrade"
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-all ${colors}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full inline-block flex-shrink-0 ${dotColor}`} />
      <span>
        {credits !== null ? credits.toLocaleString() : '—'}
        <span className="sm:hidden"> cr</span>
        <span className="hidden sm:inline"> credits</span>
      </span>
      {plan !== 'free' && planInfo?.name && (
        <span className="opacity-60 font-normal">· {planInfo.name}</span>
      )}
      {low && (
        <span className="ml-0.5 bg-red-500 text-white rounded px-1.5 py-0.5 text-[9px] font-black tracking-wide">LOW</span>
      )}
    </button>
  );
}
